import { trustBadges } from '@/mocks/homeData';

export default function TrustSection() {
  return (
    <section className="relative -mt-10 z-30">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="glass-card-strong rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-sm">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
            {trustBadges.map((badge, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center p-3 rounded-xl hover:bg-background-100 transition-colors duration-300 group"
              >
                <div className="w-11 h-11 rounded-full bg-primary-50 flex items-center justify-center mb-2.5 group-hover:bg-primary-100 transition-colors duration-300">
                  <i className={`${badge.icon} text-primary-500 text-lg`}></i>
                </div>
                <h4 className="text-foreground-900 font-semibold text-xs md:text-sm whitespace-nowrap">{badge.label}</h4>
                <p className="text-foreground-500 text-[11px] mt-0.5 hidden md:block">{badge.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}